export type ArticleResource = {
  version: string;
  heading: string;
  description: string;
  file: string;
  linkLabel: string;
};

// Downloadable assets attached to specific blog posts (keyed by current slug).
export const ARTICLE_RESOURCES: Record<string, ArticleResource> = {
  'interview-scorecard-template': {
    version: '14 September 2026',
    heading: 'Download the blank interview scorecard',
    description:
      'Open the CSV in Excel, Google Sheets, or Numbers. It includes six weighted competencies, evidence prompts, a 1–5 rating guide, and a weighted-score column.',
    file: '/resources/interview-scorecard-template.csv',
    linkLabel: 'Download CSV template',
  },
  'candidate-screening-process': {
    version: '14 September 2026',
    heading: 'Download the candidate screening checklist',
    description:
      'A working checklist with role setup, application quality, scoring review, invitations, completion, and client handoff sections. Owners and completion fields are left blank so your team can fill them in.',
    file: '/resources/candidate-screening-checklist.csv',
    linkLabel: 'Download CSV checklist',
  },
  'screening-interview-questions': {
    version: '14 September 2026',
    heading: 'Download the screening question bank',
    description:
      'The full question bank with the purpose of each question, a suggested follow-up, and space for your own role-specific additions.',
    file: '/resources/candidate-screening-questions.csv',
    linkLabel: 'Download CSV question bank',
  },
  'structured-interview-questions': {
    version: '14 September 2026',
    heading: 'Download all 40 structured interview questions',
    description:
      'Every question grouped by competency, with the evidence to look for, a blank 1–5 rating column, and the rating guide. Use it as a human interview worksheet.',
    file: '/resources/structured-interview-questions.csv',
    linkLabel: 'Download CSV question set',
  },
  'structured-hiring-process': {
    version: '14 September 2026',
    heading: 'Download the client kickoff worksheet',
    description:
      'The kickoff questions to agree with a client before screening starts: role outcomes, must-have criteria, decision ownership, handoff format, and the standing review-meeting agenda.',
    file: '/resources/client-kickoff-worksheet.csv',
    linkLabel: 'Download CSV worksheet',
  },
  'recruitment-metrics': {
    version: '14 September 2026',
    heading: 'Download the screening metrics tracker',
    description:
      'One row per role per week: application, parsing, duplicate, shortlist, interview and client-submission counts, plus every rate written out as a formula with its owner. Sample values are illustrative.',
    file: '/resources/resume-screening-metrics-tracker.csv',
    linkLabel: 'Download CSV tracker',
  },
  'ai-hiring-software': {
    version: '14 September 2026',
    heading: 'Download the vendor evaluation sheet',
    description:
      'One column per vendor across workflow, candidate experience, access and sharing, plan entitlements, integrations, data handling and proof — plus pilot acceptance criteria. Every row is marked demonstrated or not shown, never scored on a sales claim.',
    file: '/resources/ai-hiring-vendor-evaluation.csv',
    linkLabel: 'Download CSV evaluation sheet',
  },
  'how-to-reduce-time-to-hire': {
    version: '14 September 2026',
    heading: 'Download the time-to-hire baseline worksheet',
    description:
      'Nine timestamps per placement, the seven gaps to calculate from them with the party who controls each, and a standing review log. Measure your own baseline before setting any target.',
    file: '/resources/time-to-hire-baseline-worksheet.csv',
    linkLabel: 'Download CSV worksheet',
  },
  'time-to-fill': {
    version: '14 September 2026',
    heading: 'Download the time-to-first-shortlist worksheet',
    description:
      'The exact start and end events, nine timestamps per role, the seven intervals to calculate with the usual fix for each, how this differs from time to hire, and a review log.',
    file: '/resources/time-to-shortlist-worksheet.csv',
    linkLabel: 'Download CSV worksheet',
  },
  'high-volume-recruiting': {
    version: '14 September 2026',
    heading: 'Download the high-volume requirements checklist',
    description:
      'Agency requirements across capacity and entitlements, intake and screening, the interview stage, stage rules, candidate and client experience, data and export, and support — plus what is out of scope for a screening tool and the questions to settle before a pilot.',
    file: '/resources/high-volume-requirements-checklist.csv',
    linkLabel: 'Download CSV checklist',
  },
};

